<template>
  <div fluid class="cards-container">
    <v-row no-gutters>
      <slot name="header" />
    </v-row>
    <v-row no-gutters class="start">
      <slot
        v-for="item in truncatedItems"
        name="item"
        :item="item"
      />
    </v-row>
    <v-row no-gutters v-if="pagination" justify="end">
      <v-col class="py-0" cols="auto">
        <v-btn-toggle v-if="pagination" v-model="rowCount" color="primary" borderless dense group mandatory tile
                      @change="onRowCountChange"
        >
          <v-btn v-for="rowValue in rowValues" :key="`row-button-${rowValue}`" :value="rowValue" small width="34">
            {{ rowValue }}
          </v-btn>
        </v-btn-toggle>
        <v-btn class="pa-0 mr-2" color="primary" @click="onShowMoreClick" icon large :disabled="showMoreDisabled">
          <v-icon class="fas fa-angle-down" />
        </v-btn>
        <v-btn class="pa-0" color="primary" @click="onShowLesserClick" icon large :disabled="showLesserDisabled">
          <v-icon class="fas fa-angle-double-up" />
        </v-btn>
      </v-col>
      <v-col cols="12">
        <v-divider />
      </v-col>
    </v-row>
  </div>
</template>
<script>
const PAGINATION_ROW_VALUES = [8, 16, 32, 100];

export default {
  name: 'DocumentCardIterator',
  data() {
    return {
      noDataTextValue: '',
      rowCount: PAGINATION_ROW_VALUES[0],
      rowIndex: 1,
      showMoreDisabled: true,
      truncatedItems: null,
    };
  },
  computed: {
    rowValues: {
      get() {
        if (this.pagination.length) {
          return this.pagination;
        }
        return PAGINATION_ROW_VALUES;
      },
    },
    showLesserDisabled() {
      return this.rowIndex <= 1;
    },
  },
  props: {
    displayNumDocuments: {
      type: Boolean,
      default: true,
    },
    pagination: {
      type: [Boolean, Array],
      default: false,
    },
    items: {
      type: Array,
      default: () => ([]),
    },
  },
  mounted() {
    this.updatePagination(this.items);
  },
  methods: {
    isShared(document) {
      return !!document.ownerGroupId
          || (!!document.diffusions && document.diffusions.some(diffusion => diffusion.sharedToUsers.length > 0));
    },
    onRowCountChange() {
      this.updatePagination(this.items);
    },
    onShowLesserClick() {
      this.rowIndex = 1;
      this.updatePagination(this.items);
    },
    onShowMoreClick() {
      this.rowIndex++;
      this.updatePagination(this.items);
    },
    updatePagination(items) {
      if (this.pagination) {
        if (items) {
          const maxLength = this.rowIndex * this.rowCount;
          this.showMoreDisabled = (maxLength >= items.length);
          this.truncatedItems = items.slice(0, Math.min(maxLength, items.length));
        } else {
          this.showMoreDisabled = true;
        }
      } else {
        this.truncatedItems = [...items];
      }
    },
  },
  watch: {
    items(nextItems) {
      this.updatePagination(nextItems);
    },
  },
};
</script>
<style scoped>
.cards-container {
  min-width: 0;
  padding: 0;
  flex-grow: 1;
}

.row {
  margin-top: 0px;
}
</style>
